import { render, staticRenderFns } from "./OnboardingStepperFirstEditor.vue?vue&type=template&id=1308467c&scoped=true&"
import script from "./OnboardingStepperFirstEditor.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepperFirstEditor.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStepperFirstEditor.vue?vue&type=style&index=0&id=1308467c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1308467c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VStepper } from 'vuetify/lib'
import { VStepperContent } from 'vuetify/lib'
import { VStepperHeader } from 'vuetify/lib'
import { VStepperItems } from 'vuetify/lib'
import { VStepperStep } from 'vuetify/lib'
installComponents(component, {VDivider,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
